document.documentElement.classList.remove('no-js');

customElements.define('pet-menu', class extends HTMLElement {
  connectedCallback() {
    const button = this.querySelector('.menu-toggle');
    const panel = this.querySelector('[data-menu]');
    if (button && panel) {
      button.addEventListener('click', () => {
        const open = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!open));
        panel.hidden = open;
      });
    }
    const closeDropdowns = (except) => {
      this.querySelectorAll('.nav-item--dropdown[open]').forEach((el) => {
        if (el !== except) el.removeAttribute('open');
      });
    };
    document.addEventListener('click', (event) => {
      const dropdown = event.target.closest('.nav-item--dropdown');
      closeDropdowns(this.contains(event.target) ? dropdown : null);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeDropdowns(null);
    });
  }
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-sort-by]');
  if (!select) return;
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', select.value);
  window.location.assign(url.toString());
});

customElements.define('product-gallery', class extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const thumb = event.target.closest('.gallery-thumb');
      if (!thumb) return;
      const index = thumb.dataset.index;
      this.querySelectorAll('.gallery-slide').forEach((slide) => slide.classList.toggle('is-active', slide.dataset.index === index));
      this.querySelectorAll('.gallery-thumb').forEach((btn) => btn.classList.toggle('is-active', btn.dataset.index === index));
    });
  }
});

customElements.define('related-products', class extends HTMLElement {
  connectedCallback() {
    const url = this.dataset.url;
    if (!url) return;
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const grid = doc.querySelector('.product-grid');
        const target = this.querySelector('[data-container]');
        if (grid && grid.children.length && target) {
          target.innerHTML = grid.innerHTML;
        } else if (this.closest('section')) {
          this.closest('section').remove();
        }
      })
      .catch(() => {
        const section = this.closest('section');
        if (section) section.remove();
      });
  }
});

customElements.define('breed-filter', class extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[type="search"]');
    this.countEl = this.querySelector('[data-count]');
    this.noResults = document.querySelector('[data-no-results]');
    this.queryEl = this.noResults ? this.noResults.querySelector('[data-query]') : null;
    this.groups = document.querySelectorAll('.breed-directory-group');
    if (!this.input) return;
    this.input.addEventListener('input', () => this.filter());
  }
  filter() {
    const term = this.input.value.trim().toLowerCase();
    let totalVisible = 0;
    this.groups.forEach((group) => {
      let groupVisible = 0;
      group.querySelectorAll('.breed-directory-links a').forEach((link) => {
        const match = !term || link.textContent.toLowerCase().includes(term);
        link.hidden = !match;
        if (match) groupVisible += 1;
      });
      group.hidden = groupVisible === 0;
      totalVisible += groupVisible;
    });
    if (this.countEl) {
      this.countEl.textContent = term ? (totalVisible + (totalVisible === 1 ? ' breed found' : ' breeds found')) : '';
    }
    if (this.noResults) {
      this.noResults.hidden = totalVisible !== 0;
      if (this.queryEl) this.queryEl.textContent = this.input.value.trim();
    }
  }
});
customElements.define('pet-slider', class extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.slider-slide'));
    this.dots = Array.from(this.querySelectorAll('.slider-dot'));
    this.prevBtn = this.querySelector('.slider-arrow--prev');
    this.nextBtn = this.querySelector('.slider-arrow--next');
    this.index = 0;
    if (this.slides.length < 2) return;
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.index - 1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.index + 1));
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));
    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.start();
  }
  go(i) {
    this.index = (i + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, n) => slide.classList.toggle('is-active', n === this.index));
    this.dots.forEach((dot, n) => dot.classList.toggle('is-active', n === this.index));
  }
  start() {
    const ms = parseInt(this.dataset.autoplay, 10);
    if (!ms) return;
    this.stop();
    this.timer = setInterval(() => this.go(this.index + 1), ms);
  }
  stop() {
    if (this.timer) clearInterval(this.timer);
  }
});
